import { combineReducers } from "@reduxjs/toolkit";

import userReducer from "./slice/userSlice";
import roleReducer from "./slice/rolesSlice";
import clientReducer from "./slice/clientSlice";
import uiReducer from "./slice/uiSlice";
import verificationSlice from "./slice/verificationSlice";
import integrationsReducer from "./slice/integrationsSlice";
import hotelReduser from "./slice/hotelsSlice";
import arrivalsReducer from "./slice/arrivalsSlice";
import reservationReducer from "./slice/reservationSlice";
import guestReducer from "./slice/guestSlice";
import requestReducer from "./slice/requestSlice";
import dashboardReducer from "./slice/dashboardSlice";
import operationsReducer from "./slice/operationsSlice";
import maintenanceReducer from "./slice/maintenanceSlice";
import satisfactionReducer from "./slice/satisfactionSlice";
import houseKeepigReducer from "./slice/housekeepingSlice";
import pusherReducer from "./slice/pusherSlice";

const appReducer = combineReducers({
  ui: uiReducer,
  user: userReducer,
  hotels: hotelReduser,
  clients: clientReducer,
  roles: roleReducer,
  verification: verificationSlice,
  integrations: integrationsReducer,
  arrivals: arrivalsReducer,
  reservation: reservationReducer,
  guests: guestReducer,
  requests: requestReducer,
  dashboard: dashboardReducer,
  operations: operationsReducer,
  maintenance: maintenanceReducer,
  satisfaction: satisfactionReducer,
  housekeeping: houseKeepigReducer,
  pusher: pusherReducer,
});

const rootReducer = (state, action) => {
  // RESET STATES ON LOGOUT
  if (action.type === "user/logout/fulfilled") {
    state = {
      user: {
        authInitialized: true,
      },
    };
  }

  return appReducer(state, action);
};

export default rootReducer;
